import { type ComponentPropsWithoutRef } from 'react';
import { type PlanType } from '@/types';
import { cn } from '@/utils';
import { AVATAR_BG_COLOR, type AvatarSize, DEFAULT_AVATAR_IMAGE, PLAN_GRADIENT_CLASS, SIZE_MAP } from '../constants/avatar.constants';
export const FallbackAvatar = ({
  size = 'xs',
  planType,
  backgroundColor,
  className,
  style,
  ...props
}: ComponentPropsWithoutRef<'div'> & {
  size?: AvatarSize;
  planType?: PlanType;
  backgroundColor?: string;
}) => {
  const plan = planType ?? 'FREE';
  const gradientClass = PLAN_GRADIENT_CLASS[plan];
  if (!gradientClass) {
    return <div className={cn('relative inline-flex aspect-square shrink-0 overflow-hidden rounded-full', SIZE_MAP[size], className)} style={style} {...props}>
        <img src={DEFAULT_AVATAR_IMAGE} alt="" className="size-full object-cover" />
      </div>;
  }
  return <div className={cn('relative inline-flex aspect-square shrink-0 rounded-full p-[2px]', gradientClass, SIZE_MAP[size], className)} style={style} {...props} data-sentry-component="FallbackAvatar" data-sentry-source-file="FallbackAvatar.tsx">
      <div className="flex aspect-square size-full items-center justify-center overflow-hidden rounded-full" style={{
      backgroundColor: backgroundColor ?? AVATAR_BG_COLOR
    }}>
        <img src={DEFAULT_AVATAR_IMAGE} alt="" className="size-full object-cover" />
      </div>
    </div>;
};